import type { ErrorContext } from '../types';

import {
  captureException as originalCaptureException,
  captureMessage,
  getCurrentScope,
  withScope,
} from './lib';
import { setSentryTag } from './setSentryTag';

// Custom wrapper that accepts our ErrorContext type instead of Sentry's CaptureContext
function captureException(error: Error, errorContext?: ErrorContext): void {
  withScope((scope) => {
    if (error.message) {
      // Force deduplication by error message
      scope.setFingerprint([error.message]);
    }

    if (errorContext) {
      const { res, errorInfo, query, pathname } = errorContext;
      scope.setExtras({
        ...(res &&
          res.statusCode && {
            statusCode: res.statusCode,
          }),
        ...errorInfo,
        query,
        pathname,
      });
    }

    originalCaptureException(error);
  });
}

export { captureException, captureMessage, getCurrentScope, withScope, setSentryTag };
